/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import i18n from "../../plugins/locale/i18n";
import loadDictionary from "../../plugins/locale/load-dictionary";
import UserService from "../../service/user-service.js";

const userService = new UserService();

await loadDictionary('user-reset-user-password-window');

function ResetUserPasswordWindow({isOpenWindow, onCloseWindow, userId}) {
  const [password, setPassword] = useState('');

  const closeWindow = () => {
    setPassword('');
    onCloseWindow();
  };
  
  useEffect(() => {
    if(!isOpenWindow || !userId) return;

    userService.changePassword(userId).then(result => {
      if(result) {
        setPassword(result.password);
      }
    }).catch(error => {
      setPassword(null);
      console.error(error);
    });
  }, [isOpenWindow, userId]);

  return (
    <Modal show={isOpenWindow} onHide={closeWindow} backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>{i18n.t("user-reset-user-password-window.title")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {password !== null ? (<p className="text-center fs-4 mt-3">{password}</p>) : (<p className="text-center text-danger mt-3">{i18n.t("user-reset-user-password-window.error_message")}</p>)}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={closeWindow}>{i18n.t("user-reset-user-password-window.close_button")}</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ResetUserPasswordWindow;